import { Input, InputProps, InputRef } from 'antd';
import React from 'react';
import { SvgIcon } from '../../../shared/UIHelpers/SvgIcon/SvgIcon';
import { TabElementLabel, TabHeader, TabRow } from '../Tabs-styled';
import { getFontCssClass, SYMBOLS } from './EngravingHelpers';
import { EngravingTabContainer, FontOptionContainer, MaxCharacterWarning, StyledTextInput, SymbolContainer, TypeFaceTabRow } from './EngravingLUXE-styled';


interface Props {
  engravingText:string,
  onEngravingTextChange:(value:string)=>void,
  engravingFont:'Brush Script'|'Century Gothic'|'Snell Roundhand'|'Trajan'|'Dakota',
  engravingFontOptions:('Brush Script'|'Century Gothic'|'Snell Roundhand'|'Trajan'|'Dakota')[],
  onEngravingFontChange:(value:string)=>void,
  mobile:boolean,
  menuHeight:number,
  menuScaleFactor:number
}

interface State {
}


export default class Engraving extends React.Component<Props,State> {
  constructor(props: Props) {
    super(props);
  }

  public textInputRef:React.RefObject<InputRef> = React.createRef();

  public onTextInputChange = (e:React.SyntheticEvent) => {
		const { onEngravingTextChange } = this.props;
    const value = (e.target as HTMLInputElement).value;
		if(value.length <= 30) onEngravingTextChange(value);
	}

  public onSymbolSelect = (symbol:string) => {
    const { engravingText, onEngravingTextChange } = this.props;
    onEngravingTextChange(engravingText + symbol);
    if (this.textInputRef.current) this.textInputRef.current.focus();
  }

  public render = () => {
    const {
      engravingText,
      engravingFont,
      engravingFontOptions,
      onEngravingFontChange,
      mobile,
      menuHeight,
      menuScaleFactor
    } = this.props;

    return (
      <EngravingTabContainer mobile={mobile} menuHeight={menuHeight} menuScaleFactor={menuScaleFactor}>
        <TabHeader>ADD ENGRAVING</TabHeader>

        <TabRow>
          <TabElementLabel>Type text <MaxCharacterWarning highlight={ engravingText.length >= 30 }>(max. 30 symbols)</MaxCharacterWarning></TabElementLabel>
        </TabRow>
        <TabRow>
          <StyledTextInput
            value={engravingText}
            placeholder="Text on the Ring..."
            onChange={this.onTextInputChange}
            className={getFontCssClass(engravingFont)}
            ref={this.textInputRef}
          />
        </TabRow>
        <TabRow>
          <SymbolContainer onClick={() => this.onSymbolSelect(SYMBOLS.infinity)}>
            <SvgIcon
              type="infinity"
              style={{
                width: `${35 * menuScaleFactor}px`,
                height: 'auto',
                fill: 'inherit',
              }}
            />
          </SymbolContainer>
          <SymbolContainer onClick={() => this.onSymbolSelect(SYMBOLS.heart)}>
            <SvgIcon
              type="heart"
              style={{
                width: `${20 * menuScaleFactor}px`,
                height: 'auto',
                fill: 'inherit',
              }}
            />
          </SymbolContainer>
          <SymbolContainer onClick={() => this.onSymbolSelect(SYMBOLS.couple)}>
            <SvgIcon
              type="hearts"
              style={{
                width: `${25 * menuScaleFactor}px`,
                height: 'auto',
                fill: 'inherit',
              }}
            />
          </SymbolContainer>
        </TabRow>
        
        <TypeFaceTabRow>
          <TabElementLabel>Typeface</TabElementLabel>
        </TypeFaceTabRow>
        <TabRow>
          {engravingFontOptions.map((option) => {
            return (
              <FontOptionContainer 
                key={getFontCssClass(option)}
                className={getFontCssClass(option)}
                onClick={() => { onEngravingFontChange(option) }}
                isSelected={engravingFont === option}
              >
                Aa
              </FontOptionContainer>
            )
          })}
        </TabRow>
      </EngravingTabContainer>
    )
  }
}